import en from './translation'

//Write here all the changes to translations that are not correct
en.placeholder.zip = 'Postal code'
en.object.suggestion = 'Product suggestion | Product suggestions'
en.messages.dashboard.list.createList = 'Create new list'
en.object.message = 'Message | Messages'
en.messages.dashboard.home.orders = 'Your last orders'
en.messages.order.currentOrders = 'Your last orders'
en.label.pwForget = 'Forgot password'
en.label.day = 'Day'
en.placeholder.customerNumberPlus = 'Customer number/outlet number'
en.placeholder.location.deliverer = '@:object.deliverer'
export default en
